import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import stateReadAction from './stateRead.action.json' with { type: 'json' }

const stateReadDefinition = defineReadAutoAction(stateReadAction, 'state')

export default stateReadDefinition
